import React, {Component} from 'react';
import {changePassword} from '../../util/APIUtils';
import './Signup.css';
import {PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH} from '../../constants';

import {Button, Form, Input, notification} from 'antd';
import {Label} from "reactstrap";

const FormItem = Form.Item;

class ChangePasswordInner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPassword: {
                value: ''
            },

            password: {
                value: ''
            },

            rePassword: {
                value: ''
            },

            match: {
                params: this.props.match
            } ,
            passwordsMatch: false,

    }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event, validationFun) {
        const target = event.target;
        const inputName = target.name;        
        const inputValue = target.value;

        this.setState({
            [inputName] : {
                value: inputValue,
                ...validationFun(inputValue)
            }
        });
        console.log();
    }

    handleSubmit(event) {
        event.preventDefault();
        const changePasswordRequest = {
            key:this.props.match.params.resetKey,
            currentPassword: this.state.currentPassword.value,
            password: this.state.password.value
        };
        console.log(changePasswordRequest);
        changePassword(changePasswordRequest)
        .then(response => {
            this.props.history.push("/login");
            notification.success({
                message: 'ŞanlıUrfa Eczacı Odası',
                description: "Şifreniz Başarıyla Değiştirildi!",
                duration:30,
            })
        }).catch(error => {
            console.log("HATA--->",error);
            if (error.toString().includes('428'))
            {
                notification.error({
                    message: 'ŞanlıUrfa Eczacı Odası',
                    description: 'Mevcut Şifreniz Hatalı!'
                });
            }
            else {
                notification.error({
                    message: 'ŞanlıUrfa Eczacı Odası',
                    description: 'Özür Dilerim. Birşeyler Yanlış Gitti!'
                });
            }
        });
    }

    render() {

        ///console.log("params.resetKey",this.state.params.resetKey);
        return (
            <div className="signup-container">
                <div className="signup-content">
                    <Form onSubmit={this.handleSubmit} className="signup-form">

                        <FormItem
                            label="Mevcut Şifre"
                            validateStatus={this.state.currentPassword.validateStatus}
                            help={this.state.currentPassword.errorMsg}>
                            <Input
                                size="large"
                                name="currentPassword"
                                type="password"
                                autoComplete="off"
                                placeholder="Mevcut Şifrenizi Giriniz."
                                value={this.state.currentPassword.value}
                                onChange={(event) => this.handleInputChange(event, this.validatePassword)} />
                        </FormItem>
                        <FormItem 
                            label="Yeni Şifre"
                            validateStatus={this.state.password.validateStatus}
                            help={this.state.password.errorMsg}>
                            <Input 
                                size="large"
                                name="password" 
                                type="password"
                                autoComplete="off"
                                placeholder="6 ile 20 Karakter Arasında Bir Şifre Giriniz."
                                value={this.state.password.value} 
                                onChange={(event) => this.handleInputChange(event, this.validatePassword)} />    
                        </FormItem>
                        <FormItem
                            label="Yeni Şifre Tekrar"
                            validateStatus={this.state.rePassword.validateStatus}
                            help={this.state.rePassword.errorMsg}>
                            <Input
                                size="large"
                                name="rePassword"
                                type="password"
                                autoComplete="off"
                                placeholder="6 ile 20 Karakter Arasında Bir Şifre Giriniz."
                                value={this.state.rePassword.value}
                                onChange={(event) => this.handleInputChange(event, this.validatePassword)} />
                        </FormItem>
                        <Label className="errorMessage-red">{(this.state.password.value===this.state.rePassword.value)?"":"*Girilen Şifreler Uyuşmuyor"}</Label>
                        <FormItem>
                            <Button type="primary" 
                                htmlType="submit" 
                                size="large" 
                                className="signup-form-button"
                                disabled={!((this.state.password.value===this.state.rePassword.value)&&(this.state.password.errorMsg===null)&&(this.state.rePassword.errorMsg===null))}>Şifre Değiştir</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }


    validatePassword = (password) => {
        if(password.length < PASSWORD_MIN_LENGTH) {
            return {
                validateStatus: 'error',
                errorMsg: `Girdiğiniz şifre çok kısa (en az  ${PASSWORD_MIN_LENGTH} karakter giriniz.)`
            }
        } else if (password.length > PASSWORD_MAX_LENGTH) {
            return {
                validationStatus: 'error',
                errorMsg: `Girdiğiniz şifre çok uzun  (en fazla ${PASSWORD_MAX_LENGTH} karakter giriniz.)`
            }
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };            
        }
    }
}

export default ChangePasswordInner;



// WEBPACK FOOTER //
// ./src/page/signup/ChangePasswordInner.js